'use es6';

import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx as _jsx } from "react/jsx-runtime";
function AddNumberToCallee({
  onClick,
  editPermissions
}) {
  let isLoadingPermissions = false;
  let canEdit = true;
  let tooltipKey = 'noAddPermissions';
  if (editPermissions) {
    isLoadingPermissions = editPermissions.get('isLoading');
    canEdit = editPermissions.get('canEdit');
    tooltipKey = isLoadingPermissions ? 'loadingPermissions' : tooltipKey;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: canEdit,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `callee-selection.phoneNumberErrors.${tooltipKey}`
    }),
    children: /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "calling-phone-option",
      children: /*#__PURE__*/_jsx(Link, {
        "data-selenium-test": "phone-property-button",
        onClick: onClick,
        "data-enabled": !canEdit || isLoadingPermissions,
        disabled: !canEdit || isLoadingPermissions,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          paddingBlockEnd: "200",
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callee-selection.phoneNumbers.addNewNumberProperty"
          })
        })
      })
    })
  });
}
AddNumberToCallee.propTypes = {
  onClick: PropTypes.func.isRequired,
  editPermissions: ImmutablePropTypes.map
};
export default /*#__PURE__*/memo(AddNumberToCallee);